import { render, staticRenderFns } from "./TheSlider.vue?vue&type=template&id=a5a56748&"
import script from "./TheSlider.vue?vue&type=script&lang=js&"
export * from "./TheSlider.vue?vue&type=script&lang=js&"
import style0 from "./TheSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
